import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";

class MajetekVypis extends Component {
  state = {};

  componentDidMount = () => {
    this.nactiMajetek();
  };

  nactiMajetek = async () => {
    const majetek = await httpService.post(
      config.apiEndpoint + "majetek/majetekVypis.php"
    );
    this.setState({ loaded: true, majetek: majetek.data.majetek });
  };

  render() {
    const { majetek, loaded } = this.state;
    return (
      <React.Fragment>
        {loaded ? (
          majetek && majetek.length > 0 ? (
            <React.Fragment>
              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Skupina</th>
                    <th>Popis majetku</th>
                    <th>Datum pořízení</th>
                    <th>Datum vyřazení</th>
                  </tr>
                </thead>
                <tbody>
                  {majetek.map((m) => (
                    <tr key={m.majetek_id}>
                      <td>{m.majetek_id}</td>
                      <td>{m.technicka_uroven_nazev}</td>
                      <td>{m.majetek_nazev}</td>
                      <td>{m.datum_porizeni}</td>
                      <td>{m.datum_vyrazeni}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </React.Fragment>
          ) : (
            <div className="alert alert-danger">
              Nemáš přidělený žádný majetek
            </div>
          )
        ) : (
          "Loading..."
        )}
      </React.Fragment>
    );
  }
}

export default MajetekVypis;
